import { useRef, useState } from 'react';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
if (!backendUrl) throw new Error('REACT_APP_BACKEND_URL is required.');

export const useInquiry = () => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [receipt, setReceipt] = useState(null);
  const request = useRef(null);
  const sending = useRef(false);

  const submit = async event => {
    event.preventDefault();
    if (sending.current) return;
    const form = new FormData(event.currentTarget);
    const details = Object.fromEntries(['name', 'email', 'phone', 'project_description']
      .map(key => [key, String(form.get(key) || '').trim()]));
    setError('');
    if (!details.name || !details.project_description) {
      setError('Please enter your name and a description.');
      return;
    }
    if (!details.email && !details.phone) {
      setError('Please provide an email address or phone number.');
      return;
    }
    if (details.phone && (!/^[+\d\s().-]+$/.test(details.phone) ||
      !/^\d{7,15}$/.test(details.phone.replace(/\D/g, '')))) {
      setError('Please enter a valid phone number with 7 to 15 digits.');
      return;
    }
    const context = String(form.get('project_context') || '').trim();
    if (context) details.project_description = `${context}\n\n${details.project_description}`;
    const signature = JSON.stringify(details);
    if (request.current?.signature !== signature) {
      request.current = { signature, id: crypto.randomUUID() };
    }
    sending.current = true;
    setBusy(true);
    try {
      const response = await axios.post(`${backendUrl}/api/inquiries`, {
        ...details, request_id: request.current.id,
      }, { timeout: 20000 });
      setReceipt(response.data);
    } catch (failure) {
      const detail = failure.response?.data?.detail;
      const validation = Array.isArray(detail) ? detail[0]?.msg?.replace(/^Value error, /, '') : detail;
      setError(typeof validation === 'string' ? validation :
        'We couldn’t confirm your submission. Please try again; your details are still here.');
    } finally {
      sending.current = false;
      setBusy(false);
    }
  };

  return { busy, error, receipt, submit };
};